import type { ReactNode } from 'react';

import styles from './Chip.module.scss';

/**
 * A small pill label for technologies and tags.
 *
 * Deliberately not glass. Chips appear in dozens, often on glass already,
 * and a backdrop pass for each would cost far more than it shows.
 */
export const Chip = ({ children }: { readonly children: ReactNode }) => (
  <span className={styles.chip}>{children}</span>
);
